/**
 * @(#)2019/7/15.
 * Cascader，用于级联数据选择
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
import React from "react";
import Basics from "./Basics";
import { Cascader } from "antd";
import { isArray, isEqual } from "lodash";
import Config from "../../config";
import { EventEmitter } from "events";
import request from "../../utils/request";
import { l } from "../../config/language";
import { get, cloneDeep } from "../../utils";
import { YxComponent, Connection } from "../YxComponent";
import { ICascaderPropTypes } from "./IpropType/cascaderPropType";

let defaul = function () {
  return {
    version: null,
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
    // 默认props
    data: [], // 级联数据
    value: [], // 默认选中
    depth: null, // 级联深度
    request: null, // 级联请求参数
    defaultValue: [], // 默认选中值
    isAutoWidth: false, // 是否开启自适应
    requestCallback: null, // 级联请求数据回调
    dataPath: Config.input.cascader.dataPath, // 请求数据的数据路径
    inputParam: {
      options: [],
      placeholder: l("YxCascader.ipt"),
      changeOnSelect: false,
    },
    rules: {},
    children: "",
    formItemParamer: {},
    change: function () {},
  };
};

/**
 * 用于级联选择器，参数请查阅antd的组件 Cascader
 * @param  {number} depth 级联深度
 * @param  {Function(value,inputId,event,itemData)} change 当值发生变化时回调
 * @param  {object} request 级联请求参数 默认为null
 * @param  {Array<object>} defaultValue 默认选中参数
 * @param  {string} dataPath 请求结果的数据路径 默认为 data
 * @param  {Array<object>} data 级联数据，优先级会比请求数据高
 * @param  {boolean} isAutoWidth 是否开启根据文本内容自动伸缩宽度
 * @param  {Function} requestCallback 当 request 不为空的时候 请求回调，默认 null
 * @param {boolean} requestDefaultValue 默认false
 * @param {object} styleParam {object} 样式参数
 * @param {string} styleParam.width {string} 宽度  xxs,xs,sm,md,lg,xl
 * @param {string} styleParam.type {string} 类型
 * @param {string} styleParam.size {string} 大小
 * @class YxCascader
 * @extends {YxComponent}
 */
@Connection(defaul)
class YxCascader extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      width: "",
      ascaderData: [],
      className: "yx_yxInput_cascader",
      defaultValue: "",
    };
    this.version = get(this.props, "version", null);
    this.eventEmitter = new EventEmitter();
  }

  async componentDidMount() {
    await this.stateCascaderData();
    const defaultValue = get(this.props, "defaultValue", []);
    this.autoWidth(defaultValue);
    this.eventEmitter.addListener("auto", this.autoWidth);
    get(this.props, "load", () => {})(this.props.form);
  }

  componentWillReceiveProps(nextProps) {
    const { version } = nextProps;
    if (!isEqual(version, this.version)) {
      this.stateCascaderData();
      this.version = version;
    }
  }

  /**
   * 输入框宽度适应函数
   *
   * @param {Array} value
   * @returns
   * @memberof YxCascader
   */
  autoWidth = (value) => {
    if (!this.props.isAutoWidth) return;
    const { className } = this.state;
    let span = document.querySelector(`.${className}`);
    if (span == null) return "100%";
    let input = span.querySelector(".ant-input.ant-cascader-input");
    let fontSize = getComputedStyle(input).fontSize || "12px";
    fontSize = fontSize.replace("px", "");
    let number = value.join("").length;
    let width = parseFloat(fontSize) * number + "px";
    this.setState({ width });
  };

  /**
   * 当传入请求参数对象时执行接口请求
   *
   * @memberof YxCascader
   */
  async stateCascaderData() {
    let requestParam = get(this.props, ["requestParam", "request"]);
    if (requestParam) {
      let response = await request(requestParam);
      let dataPath = get(this.props, "dataPath", "data");
      let data = get(response, dataPath, []);
      const { requestCallback } = this.props;
      if (requestCallback instanceof Function) {
        data = requestCallback(response) || data;
      }
      this.setState({ data, defaultValue: this.getRecursion(data) });
    }
  }

  getRecursion(data) {
    let value = [];
    if (!isArray(data)) return data;
    value.push(get(data, "[0]value", ""));
    if (get(data, "[0].children.length", 0) > 0) {
      value.push(this.getRecursion(get(data, "[0].children")));
    }
    return value.flat();
  }

  get cascaderData() {
    let dataPath = get(this.props, "dataPath", "data");

    /* 当porps.data 空或length ==0 ，request 返回长度大于0 */
    if (
      get(this.props, dataPath, []).length <= 0 &&
      this.state.data.length > 0
    ) {
      return this.state.data;
    } else {
      return get(this.props, dataPath, []);
    }
    // return get(this.props, dataPath, null) || this.state.data
  }

  /**
   * data预处理
   *
   * @param {Array} data
   * @returns
   * @memberof YxCascader
   */
  preprocessed(data) {
    for (let item of data) {
      if (item.value && item.label) {
        continue;
      } else if (item.label && !item.value) {
        item.value = item.label;
      } else if (!item.label && item.value) {
        item.label = item.value;
      } else {
        throw {
          msg: "级联抛出一个错误，data的子节点中 label、value至少一个有值",
          data,
        };
      }
      if (item.children instanceof Array) {
        item.children = this.preprocessed(item.children);
      }
    }
    return data;
  }

  /**
   * 根据 depth 截断 data
   *
   * @param {Array} data
   * @param {number} depth
   * @returns Array
   * @memberof YxCascader
   */
  cutOffdata(data, depth) {
    if (depth == null) {
      return data;
    }
    if (depth == 0) {
      data.forEach((item) => {
        delete item.children;
      });
      return data;
    } else {
      return data.map((item) => {
        if (item.children instanceof Array) {
          item.children = this.cutOffdata(item.children, depth - 1);
        }
        return item;
      });
    }
  }

  /**
   * 对 tmpProps 的 data 初始化处理
   * 1.截断 data
   * 2.预处理 data
   * @param {object} tmpProps
   * @returns
   * @memberof YxCascader
   */
  dataInit(tmpProps) {
    let data = get(tmpProps, "data", null);
    if (data instanceof Array) {
      data = this.cutOffdata(data, this.props.depth);
      data = this.preprocessed(data);
    }
  }

  onChange(value, inputId, event, itemData) {
    this.eventEmitter.emit("auto", value);
    this.props.change && this.props.change(value, inputId, event, itemData);
  }

  /**
   * 外层属性值渗透到 inputParam
   *
   * @param {object} tmpProps
   * @returns
   * @memberof YxCascader
   */
  penetration(tmpProps) {
    let inputParam = tmpProps.inputParam;
    tmpProps.change = (value, inputId, event, itemData) => {
      this.onChange(value, inputId, event, itemData);
    };
    inputParam.options = this.cascaderData;
    return tmpProps;
  }

  productionHtml() {
    let { defaultValue } = this.state;
    let tmpProps = { ...this.props };
    tmpProps.rules.max = "";
    this.dataInit(tmpProps);
    tmpProps = this.penetration(tmpProps);
    if (
      get(tmpProps, "defaultValue.length", 0) <= 0 &&
      tmpProps.requestDefaultValue
    ) {
      tmpProps.defaultValue = defaultValue;
    }
    delete tmpProps.className;
    tmpProps.children = <Cascader style={{ minWidth: this.state.width }} />;
    let classParam = {
      yx_yxCascader_: "styleParam.type",
      yx_yxCascader_size_: "styleParam.size",
      yx_yxInput_width_: "styleParam.width",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );
    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    const stateClass = this.state.className;
    const propsClass = get(this.props, "className", "");
    const className = [stateClass, propsClass];
    return <div className={className.join(" ")}>{this.productionHtml()}</div>;
  }
}

YxCascader.propTypes = ICascaderPropTypes;
YxCascader.defaultProps = defaul();
export default YxCascader;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxCascader.js